import { getDeviceInfo } from "@puregym/utilities";

const { isBrowser } = getDeviceInfo();

export const pushDataLayer = (data, timeout = 2000) => {
  if (isBrowser) {
    return new Promise((resolve) => {
      window.dataLayer.push({
        ...data,

        eventCallback: () => {
          resolve();
        },
      });
      setTimeout(resolve, timeout);
    });
  } else {
    return Promise.resolve();
  }
};
